const Contact = () => (
    <div>
      <h2>Contact Us</h2>
      <p>Reach out for help, partnerships, or media inquiries.</p>
    </div>
  )
  
  export default Contact
  